var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiles-item",on:{"click":function (payload) { return _vm.$emit('click', payload); }}},[_vm._t("bottom"),_vm._t("image")],2)}
var staticRenderFns = []

export { render, staticRenderFns }